module.exports = __webpack_public_path__ + "static/img/green products card_01.b888ec97.jpg";